import type { AiOperationSimulation } from '../../types/aiOperational'

export const ExecutionSimulationPanel = ({ simulation }: { simulation?: AiOperationSimulation | null }) => {
  if (!simulation) return null
  const rows = [
    simulation.estimatedAffectedRecordCount !== undefined ? `${simulation.estimatedAffectedRecordCount} affected record estimate` : '',
    simulation.rollbackAvailability ? `Rollback ${simulation.rollbackAvailability.toLowerCase().replace(/_/g, ' ')}` : '',
    simulation.integrationTouchpoints?.length ? `Touchpoints: ${simulation.integrationTouchpoints.slice(0, 3).join(', ')}` : '',
  ].filter(Boolean)
  return (
    <section className="aiExecutionSimulationPanel" aria-label="Execution simulation">
      <div className="aiExecutionPanelHeader">
        <strong>Simulation</strong>
        {simulation.riskLevel ? <span>{simulation.riskLevel.toLowerCase()} risk</span> : null}
      </div>
      <p>{simulation.summary}</p>
      {rows.length ? <div className="aiExecutionSimulationMeta">{rows.map((row) => <span key={row}>{row}</span>)}</div> : null}
      {simulation.dependencyImpacts?.length ? (
        <ul>
          {simulation.dependencyImpacts.slice(0, 4).map((impact) => <li key={impact}>{impact}</li>)}
        </ul>
      ) : null}
      {simulation.blockedOperations?.length ? (
        <ul>
          {simulation.blockedOperations.slice(0, 3).map((blocked) => <li key={blocked}>{blocked}</li>)}
        </ul>
      ) : null}
    </section>
  )
}
